import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

export default function ConfirmModal({ title, message, onConfirm, onCancel }) {
  const { t } = useTranslation();
  
  return (
    <div className="fixed inset-0 bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4 z-50" onClick={onCancel}>
      <div
        className="bg-white dark:bg-zinc-800 border-t-2 sm:border-2 border-[#18181B] dark:border-zinc-600 rounded-t-2xl sm:rounded-2xl hard-shadow p-4 sm:p-6 w-full sm:max-w-md"
        onClick={(e) => e.stopPropagation()}
        data-testid="confirm-modal"
      >
        <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#FFC247] border-2 border-[#18181B] dark:border-zinc-600 flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-5 h-5 sm:w-6 sm:h-6 text-[#18181B]" />
          </div>
          <h2 className="text-lg sm:text-xl font-bold text-zinc-900 dark:text-white">{title}</h2>
        </div>

        <p className="text-sm sm:text-base text-zinc-600 dark:text-zinc-300 mb-4 sm:mb-6">{message}</p>

        <div className="flex gap-2 sm:gap-3">
          <button
            onClick={onCancel}
            className="flex-1 rounded-full border-2 border-[#18181B] dark:border-zinc-600 bg-white dark:bg-zinc-700 text-zinc-900 dark:text-white font-bold py-2.5 sm:py-3 px-4 sm:px-6 text-sm sm:text-base hover:bg-zinc-100 dark:hover:bg-zinc-600 hover:shadow-[2px_2px_0px_0px_rgba(24,24,27,1)] active:translate-y-1 active:shadow-none transition-all"
            data-testid="confirm-cancel"
          >
            {t('modals.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 rounded-full border-2 border-[#18181B] bg-[#ADE498] text-[#18181B] font-bold py-2.5 sm:py-3 px-4 sm:px-6 text-sm sm:text-base hover:bg-[#bdeaa8] hover:shadow-[2px_2px_0px_0px_rgba(24,24,27,1)] active:translate-y-1 active:shadow-none transition-all"
            data-testid="confirm-accept"
          >
            {t('modals.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}
